module.exports = __webpack_public_path__ + "img/icon-captcha-verified.d1c4a037.svg";